import { DependencyList, useEffect } from 'react';

export const useBlurEffect = (dependency: DependencyList, shouldBlur = true) => {
    useEffect(() => {
        if (shouldBlur && document.activeElement instanceof HTMLElement) {
            (window.document.activeElement as HTMLElement)?.blur?.();
        }
    }, dependency);
};
